<template>
  <main class="premium">
    <section class="premium-keyvisual">
      <h2 class="premium-keyvisual__ttl"><span class="premium-keyvisual__logo">abceed premium</span>で<br>学習をもっと効果的に</h2>
    </section>
    <section class="premium-main">
      <h3 class="premium-main__ttl">プレミアムの概要</h3>
      <div class="premium-card">
        <section class="premium-card__main">
          <h4 class="premium-card__ttl">ディクテーション機能</h4>
          <p class="premium-card__sentence">リスニング対策には人気教材を使ったディクテーションが最適！</p>
          <p class="premium-card__caption">*学習機能の付いた教材にのみ対応</p>
        </section>
        <div class="premium-card__icon">
          <img src="/static/img/premium_icon_01.png" alt="ディクテーション機能">
        </div>
      </div>
      <div class="premium-card">
        <section class="premium-card__main">
          <h4 class="premium-card__ttl">総学習分析</h4>
          <p class="premium-card__sentence">学習問題数、単語数、学習時間を教材をまたいでグラフ化。努力量を可視化して、モチベーションを高めよう！</p>
        </section>
        <div class="premium-card__icon">
          <img src="/static/img/premium_icon_02.png" alt="総学習分析">
        </div>
      </div>
      <div class="premium-card">
        <section class="premium-card__main">
          <h4 class="premium-card__ttl">問題・単語・音声を絞り込み</h4>
          <p class="premium-card__sentence">間違えた単語や、チェックをつけた音声、難易度の高い問題など、条件に応じて絞り込み可能。</p>
        </section>
        <div class="premium-card__icon">
          <img src="/static/img/premium_icon_03.png" alt="問題・単語・音声を絞り込み">
        </div>
      </div>
      <div class="premium-card">
        <section class="premium-card__main">
          <h4 class="premium-card__ttl">教材をオフラインで利用</h4>
          <p class="premium-card__sentence">通信料を気にせずに、一度ダウンロードした教材をオフラインで利用。</p>
          <p class="premium-card__caption">*MyBooksに登録することでオフライン利用が可能</p>
        </section>
        <div class="premium-card__icon">
          <img src="/static/img/premium_icon_04.png" alt="教材をオフラインで利用">
        </div>
      </div>
      <div class="premium-card">
        <section class="premium-card__main">
          <h4 class="premium-card__ttl">MyBooks登録を無制限に</h4>
          <p class="premium-card__sentence">お気に入りの教材はMyBooksに登録しよう。MyBooksの教材はオフラインの環境でも利用可能。</p>
        </section>
        <div class="premium-card__icon">
          <img src="/static/img/premium_icon_05.png" alt="MyBooks登録を無制限に">
        </div>
      </div>
      <p class="premium-main__caption">
        ・この定期購読は自動継続購読になります。アプリを削除するだけではサービスは解約されませんのでご注意ください。<br>
        ・購読期間終了の24時間前までであれば解約（自動継続購読を停止）できます。<br>
        ・解約手続きはWebストアの「アカウント」から行えます（詳細は<a href="https://www.globeejapan.com/faq.html" target="_blank">FAQ</a>に記載）。<br>
        ・自動継続課金は購読期間終了前24時間以内に自動で行われます。</p>
      <div class="premium-nav">
        <div class="premium-nav__block premium-nav-block">
          <div class="premium-nav-block__discount premium-nav-block__discount--vacant"></div>
          <span @click="onClickPurchase(1)" class="premium-nav-block__main">
            <div class="premium-nav-block__price">{{subscriptions[1].period}}</div>
            <div class="premium-nav-block__month">¥{{subscriptions[1].price_per_month}}<span>/月</span></div>
          </span>
        </div>
        <div class="premium-nav__block premium-nav-block">
          <div class="premium-nav-block__discount">33%OFF</div>
          <span @click="onClickPurchase(2)" class="premium-nav-block__main">
            <div class="premium-nav-block__price">{{subscriptions[2].period}}</div>
            <div class="premium-nav-block__month">¥{{subscriptions[2].price_per_month}}<span>/月</span></div>
          </span>
        </div>
        <div class="premium-nav__block premium-nav-block">
          <div class="premium-nav-block__discount">45%OFF</div>
          <span @click="onClickPurchase(3)" class="premium-nav-block__main">
            <div class="premium-nav-block__price">{{subscriptions[3].period}}</div>
            <div class="premium-nav-block__month">¥{{subscriptions[3].price_per_month}}<span>/月</span></div>
          </span>
        </div>
      </div>
    </section>
  </main>
</template>

<script>

  import {credit, subscriptions_prefix } from '../../constants';

  export default {
    title: 'プレミアム | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: 'プレミアム',
    description: 'abceed のプレミアム機能の詳細はこちら',
    keywords: 'toeic,abceed,abceed analytics premium,globee,プレミアム',
    headerType: 'historyBack',
    data() {
      return {
      }
    },
    beforeCreate() {
      if (this.$store.getters.directLanding) {
        this.$router.push({ name: 'settingHome'});
      }
    },
    methods: {
      onClickPurchase(index) {
        const premium_id = this.subscriptions[index].product_id;
        const settings = this.$store.getters.userSettings.user;
        const isCreditCardAvailable = ('sbps_payment_type' in settings && settings.sbps_payment_type === credit);
        if (isCreditCardAvailable) {
          //クレカ購入済みの場合はその場で決済させる
          this.$store.dispatch("showLightBox", "loading");
          this.$store.dispatch("purchasePremiumByToken", {
            ignore_token: true,
            premium_id: premium_id
          }).then(data => {
            if (data.result) {
              //購入成功
              this.$store.dispatch("hideLightBox");
              this.$store.dispatch("showLightBox", "subscriptionResult");
              //Homeに戻す
              this.$router.push({name: 'rankingHome'});
            } else {
              this.$store.dispatch("hideLightBox");
              alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
            }
          }).catch(() => {
            this.$store.dispatch("hideLightBox");
            alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
          });
        } else {
          this.$router.push({name: 'premiumCreditCard', params: { id: premium_id.replace(subscriptions_prefix, '') }});
        }

      }
    },
    computed: {
      subscriptions() {
        return this.$store.getters.userSettings.subscriptions;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/premiums/Home.vue